import { SolanaPrivateKeyProvider } from '@web3auth/solana-provider';
import { CHAIN_NAMESPACES } from '@web3auth/base';
import { OPENLOGIN_NETWORK } from '@web3auth/openlogin-adapter';

export function createChainConfig() {
	return {
		chainNamespace: CHAIN_NAMESPACES.SOLANA,
		rpcTarget: process.env.NEXT_PUBLIC_RPC_END_POINT,
		blockExplorer: 'https://explorer.solana.com?cluster=testnet',
		chainId: '0x1',
		displayName: OPENLOGIN_NETWORK.TESTNET,
		clientId: process.env.NEXT_PUBLIC_WEB3AUTH_CLIENT_ID
	};
}

export function createPrivateKeyProvider(chainConfig) {
	const privateKeyProvider = new SolanaPrivateKeyProvider({
		config: { chainConfig }
	});
	return privateKeyProvider;
}
